// Dropdown controller for toggle menu with click-outside and escape key handling
// 用於 navbar 的下拉選單，提供：
// - Toggle 行為（點擊切換開/關）
// - 點擊外部自動關閉
// - Escape 鍵關閉

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['menu']

  connect() {
    this.closeOnClickOutside = this.closeOnClickOutside.bind(this)
    this.closeOnEscape = this.closeOnEscape.bind(this)
  }

  disconnect() {
    document.removeEventListener('click', this.closeOnClickOutside)
    document.removeEventListener('keydown', this.closeOnEscape)
  }

  toggle(event) {
    event.stopPropagation()
    if (this.menuTarget.classList.contains('hidden')) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.menuTarget.classList.remove('hidden')
    // 延遲註冊 listener，避免觸發 toggle 的那次 click 也觸發關閉
    setTimeout(() => {
      document.addEventListener('click', this.closeOnClickOutside)
      document.addEventListener('keydown', this.closeOnEscape)
    }, 0)
  }

  close() {
    this.menuTarget.classList.add('hidden')
    document.removeEventListener('click', this.closeOnClickOutside)
    document.removeEventListener('keydown', this.closeOnEscape)
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  closeOnEscape(event) {
    if (event.key === 'Escape') {
      this.close()
    }
  }
}
